// SPDX-License-Identifier: AGPL-3.0-or-later

export const PRODUCT_NAME = 'OmniVybe';
export const DEFAULT_PREMIUM_PRODUCT_NAME = 'Pulse';
